var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// @ts-ignore
import { default as ReactSelect } from 'react-select-v1';
import styled from 'styled-components';
import 'react-select-v1/dist/react-select.css';
import { Site, Entity } from '@debbie/common/dist';
import { ActivityType } from '@debbie/common/dist/web-sockets';
import helpers from '@debbie/common/dist/economy/helpers';
import { c, h } from '@debbie/cortex/dist';
import { selectCaseUpdates } from '@debbie/cortex/dist/case/selectors';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors';
import { useConnectCaseMappingOnCase } from '@debbie/cortex/dist/connect';
import { selectMe } from '@debbie/cortex/dist/me/selectors';
import { selectActiveUsers } from '@debbie/cortex/dist/users/selectors';
import { TypingIndicator } from '..';
import THEME from '../../theme';
import Filter from '../Icons/Filter';
import SearchIcon from '../Icons/Search';
import Input from '../Input';
import PlaceholderLoader from '../PlaceholderLoader';
import HistItemTypes from './HistItemTypes';
import { HistItemType } from './itemTypes';
import { InteractionType } from '@debbie/common/dist/interactions';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers';
import { interactionsByReferenceKey, useInteractionsByReference, } from '@debbie/cortex/dist/interactions';
import q from '@debbie/cortex/dist/query';
const CaseHistory = (props) => {
    const me = useSelector(selectMe);
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const singleCase = useSelector((s) => selectCaseById(s, props.caseId));
    const caseInteractionsLoadable = useInteractionsByReference(Entity.Case, singleCase === null || singleCase === void 0 ? void 0 : singleCase.caseId);
    const caseInteractions = h.hasData(caseInteractionsLoadable)
        ? caseInteractionsLoadable.data
        : null;
    const caseUpdates = useSelector((s) => singleCase && selectCaseUpdates(s, singleCase.caseId));
    const connectCaseMappings = useConnectCaseMappingOnCase(site === Site.Caseworker ? singleCase === null || singleCase === void 0 ? void 0 : singleCase.caseId : undefined);
    const activeUsers = useSelector((s) => singleCase && selectActiveUsers(s, singleCase.tenantId));
    const caseVouchers_ = useCaseVouchersByCase(singleCase === null || singleCase === void 0 ? void 0 : singleCase.caseId);
    const _caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const isLoading = useSelector((s) => {
        return (singleCase &&
            (h.isLoading(s.cases[props.caseId]) ||
                h.isLoading(s.caseUpdates[props.caseId])));
    }) || h.isLoading(caseInteractionsLoadable);
    const [fromVouchers, setFromVouchers] = useState(null);
    const [state, setState] = useState({
        q: '',
        search: true,
        histFilterSelect: [],
    });
    const [items, setItems] = useState({
        [HistItemType.Interactions]: [],
        [HistItemType.Updates]: [],
        [HistItemType.VoucherCollection]: [],
        [HistItemType.CaseCreation]: [],
        [HistItemType.CaseStatus]: [],
        [HistItemType.ConnectUpdate]: [],
    });
    useEffect(() => {
        props.caseId && updateCase();
    }, [props.caseId]);
    useEffect(() => {
        if (site === Site.Debtor
            ? caseInteractions && _caseVouchers && singleCase
            : singleCase && (caseInteractions || caseUpdates || _caseVouchers)) {
            setItems({
                [HistItemType.Interactions]: getInteractions(),
                [HistItemType.Updates]: getUpdates(),
                [HistItemType.VoucherCollection]: getVouchers(),
                [HistItemType.CaseCreation]: getCaseCreation(),
                [HistItemType.CaseStatus]: getCaseStatus(),
                [HistItemType.ConnectUpdate]: getConnectUpdates(),
            });
        }
    }, [
        caseInteractions,
        caseUpdates,
        _caseVouchers,
        singleCase,
        fromVouchers,
        connectCaseMappings.loadingState,
    ]);
    const getInteractions = () => {
        if (caseInteractions) {
            return caseInteractions.map((i, index) => ({
                key: i.id || `interactions_${index}`,
                type: HistItemType.Interactions,
                date: `${i.createdAt || i.transacted}`,
                data: i,
            }));
        }
        return [];
    };
    const getUpdates = () => {
        if (caseUpdates) {
            return Object.values(caseUpdates
                .filter((u) => u.hiddenPermissionLevel !== (me === null || me === void 0 ? void 0 : me.role))
                .reduce((acc, update) => {
                var _a;
                const key = `${update.updateTypeId}${update.continuedAt && update.continuedAt.substr(0, 13)}${update.update}${update.createdAt.substr(0, 13)}${update.state}${update.taskId}${((_a = update === null || update === void 0 ? void 0 : update.data) === null || _a === void 0 ? void 0 : _a.isCaseMergeDetails) ? update.updateId : ''}`;
                if (Array.isArray(acc[key])) {
                    acc[key].push(update);
                }
                else {
                    acc[key] = [update];
                }
                return acc;
            }, {})).map((updates) => ({
                key: updates[0].updateId,
                type: HistItemType.Updates,
                timespan: {
                    from: updates[0].createdAt,
                    to: updates[0].continuedAt || null,
                },
                data: updates,
            }));
        }
        return [];
    };
    const getCaseStatus = () => {
        if (singleCase && singleCase.statusLog && site !== Site.Debtor) {
            return singleCase.statusLog.map((s) => ({
                key: s.createdAt + singleCase.caseId,
                type: HistItemType.CaseStatus,
                date: s.createdAt,
                data: s,
            }));
        }
        return [];
    };
    const getVouchers = () => {
        if (_caseVouchers) {
            let kaseVouchers = _caseVouchers;
            if (site === Site.Debtor) {
                kaseVouchers = helpers.vouchers.postProcessing(kaseVouchers, {
                    includeIrrecoverableVouchers: false,
                    includeDeletedVouchers: false,
                    includeExpiredVouchers: false,
                });
            }
            const voucherChildren = kaseVouchers.reduce((acc, kaseVoucher) => {
                const key = kaseVoucher.referenceCaseVoucherId;
                if (Array.isArray(acc[key])) {
                    acc[key].push(kaseVoucher);
                }
                else {
                    acc[key] = [kaseVoucher];
                }
                return acc;
            }, {});
            return Object.values(kaseVouchers
                .map((v) => {
                return Object.assign(Object.assign({}, v), { children: voucherChildren[v.caseVoucherId] });
            })
                .reduce((acc, kaseVoucher) => {
                const key = kaseVoucher.createdAt.substr(0, 13);
                if (Array.isArray(acc[key])) {
                    acc[key].push(kaseVoucher);
                }
                else {
                    acc[key] = [kaseVoucher];
                }
                return acc;
            }, {})).map((kaseVouchers) => ({
                key: kaseVouchers[0].caseVoucherId,
                type: HistItemType.VoucherCollection,
                date: kaseVouchers[0].createdAt,
                data: {
                    categories: Array.from(new Set(kaseVouchers.map((v) => v.category))),
                    caseVouchers: kaseVouchers,
                    date: kaseVouchers[0].date,
                },
            }));
        }
        return [];
    };
    const getCaseCreation = () => {
        var _a;
        if (singleCase) {
            return [
                {
                    key: '',
                    type: HistItemType.CaseCreation,
                    date: singleCase.createdAt,
                    data: {
                        caseCreation: true,
                        createdBy: (_a = singleCase.createdBy) !== null && _a !== void 0 ? _a : null,
                    },
                },
            ];
        }
        return [];
    };
    const getConnectUpdates = () => {
        return h.hasData(connectCaseMappings)
            ? connectCaseMappings.data.flatMap((mapping) => mapping.updates.map((u) => {
                return {
                    key: u.id,
                    type: HistItemType.ConnectUpdate,
                    date: u.createdAt,
                    data: {
                        mapping,
                        update: u,
                    },
                };
            }))
            : [];
    };
    const filterItems = () => {
        let filteredByType = [];
        if (state.histFilterSelect.length === 0) {
            filteredByType = Object.values(items).flat();
        }
        else {
            filteredByType = state.histFilterSelect.reduce((acc, filter) => {
                if (filter.type === 'filtered_include') {
                    return [
                        ...acc,
                        ...items[filter.itemType].filter(filter.filter),
                    ];
                }
                return [...acc, ...items[filter.value]];
            }, []);
        }
        return state.q
            ? filteredByType.filter((c) => JSON.stringify(c).toLowerCase().indexOf(state.q.toLowerCase()) !==
                -1)
            : filteredByType;
    };
    const updateCase = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!singleCase) {
            yield c.cases.getById(props.caseId);
            if (!caseInteractions) {
                q.invalidate([interactionsByReferenceKey(Entity.Case, props.caseId)]);
            }
        }
    });
    if (!singleCase)
        return null;
    const filtered = filterItems().sort((a, b) => {
        var _a, _b;
        return parseInt(moment(b.date || ((_a = b.timespan) === null || _a === void 0 ? void 0 : _a.from)).format('x')) -
            parseInt(moment(a.date || ((_b = a.timespan) === null || _b === void 0 ? void 0 : _b.from)).format('x'));
    });
    return (React.createElement(HistStyled, null,
        React.createElement(HistHeadline, null,
            React.createElement("h2", null, lang.history.history),
            state.search ? (React.createElement(Input, { value: state.q, onChange: (e) => {
                    setState(Object.assign(Object.assign({}, state), { q: e.target.value }));
                }, placeholder: lang.history.searchHistory })) : (React.createElement(ReactSelect, { value: state.histFilterSelect, placeholder: lang.history.filterHistory, multi: true, removeSelected: true, options: [
                    {
                        type: 'include',
                        label: lang.history.filterUpdates,
                        value: HistItemType.Updates,
                    },
                    {
                        type: 'filtered_include',
                        label: lang.history.filterInteractions,
                        itemType: HistItemType.Interactions,
                        value: 'interactions',
                        filter: (item) => item.type === HistItemType.Interactions
                            ? item.data.type !== InteractionType.Note
                            : false,
                    },
                    {
                        type: 'include',
                        label: lang.history.filterEconomy,
                        value: HistItemType.VoucherCollection,
                    },
                    {
                        type: 'include',
                        label: lang.history.filterCaseStatus,
                        value: HistItemType.CaseStatus,
                    },
                    {
                        type: 'filtered_include',
                        label: lang.history.filterNotes,
                        value: 'interactions:notes',
                        itemType: HistItemType.Interactions,
                        filter: (item) => item.type === HistItemType.Interactions
                            ? item.data.type === InteractionType.Note
                            : false,
                    },
                ], valueRenderer: (option) => React.createElement("span", null, option.label), onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                    setState(Object.assign(Object.assign({}, state), { histFilterSelect: val }));
                }) })),
            React.createElement("div", { style: {
                    cursor: 'pointer',
                }, onClick: () => {
                    setState(Object.assign(Object.assign({}, state), { search: !state.search }));
                } }, state.search ? React.createElement(Filter, null) : React.createElement(SearchIcon, null))),
        React.createElement("div", null, activeUsers &&
            activeUsers.map((user) => user.activities.find((a) => a.handle === `${singleCase.id}`) && (React.createElement(TypingIndicator, { key: user.id, writing: !!user.activities.find((a) => [
                    ActivityType.WRITINGCLIENTNOTE,
                    ActivityType.WRITINGDEBTORNOTE,
                ].includes(a.type)) })))),
        isLoading ? (React.createElement(React.Fragment, null,
            React.createElement("div", { style: {
                    marginLeft: '75px',
                } },
                React.createElement(PlaceholderLoader, { width: "80%" })),
            React.createElement("div", { style: {
                    marginLeft: '75px',
                } },
                React.createElement(PlaceholderLoader, { width: "45%" })),
            React.createElement("div", { style: {
                    marginLeft: '75px',
                } },
                React.createElement(PlaceholderLoader, { width: "60%" })))) : (filtered.map((h, index) => (React.createElement("div", { className: "history-entry", key: `${h.type}-${h.key}`, id: `ui-test-4a648d7d-${index}` },
            React.createElement(HistItemTypes, { historyItem: h, singleCase: singleCase, referenceId: singleCase.caseId, referenceType: Entity.Case })))))));
};
export default CaseHistory;
const HistStyled = styled.div `
  padding-bottom: 20px;
`;
const HistHeadline = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  svg {
    height: 20px;
    width: 20px;
  }

  h2 {
    display: inline-block;
  }
  .Select {
    display: inline-block;
    margin: 0 ${THEME.GRID_SPACING}px;
    flex-grow: 2;
  }

  .iris-input-container {
    display: inline-block;
    margin: 0 ${THEME.GRID_SPACING}px;
    flex-grow: 2;

    input {
      box-shadow: none !important;
      padding: 14px 15px 2px 20px !important;
      border: none !important;
      border-radius: 20px;
      margin-bottom: 0;

      &:focus ~ .inp-placeholder {
        top: 5px !important;
      }
    }

    .inp-placeholder {
      left: 20px;
      top: 10px !important;
    }
  }
`;
//# sourceMappingURL=CaseHistory.js.map